import { FC, ComponentType } from 'react';
import {
  MedicalServicesOutlined,
  PlaceOutlined,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material/SvgIcon';
import {
  MedicationIcon,
  PillIcon,
  SyringeIcon,
  WaterDropIcon,
} from '../../../icons/MedicineFormIcons';
import styles from './medicine-card.module.css';

const getFormIcon = (formaFarmaceutica: string): ComponentType<SvgIconProps> => {
  const f = formaFarmaceutica.toLowerCase();
  if (f.includes('injet') || f.includes('seringa') || f.includes('ampola')) {
    return SyringeIcon;
  }
  if (
    f.includes('solução') ||
    f.includes('solucao') ||
    f.includes('xarope') ||
    f.includes('gotas')
  ) {
    return WaterDropIcon;
  }
  if (f.includes('comprimido') || f.includes('cápsula') || f.includes('capsula')) {
    return PillIcon;
  }
  return MedicationIcon;
};

export interface MedicineCardProps {
  title: string;
  formaFarmaceutica: string;
  localDeRetirada: string;
  indicacao: string;
  componenteAgrupado: string;
  responsabilidade: string;
  disponibilidade: string;
}

// ES-868: tag de disponibilidade desativada — manter para reativação futura
// const isAvailable = (disponibilidade: string) =>
//   disponibilidade.trim().toLowerCase().startsWith('com');

export const MedicineCard: FC<MedicineCardProps> = ({
  title,
  formaFarmaceutica,
  localDeRetirada,
  indicacao,
  componenteAgrupado,
  responsabilidade,
  // disponibilidade, // ES-868: desativado — manter para reativação futura
}) => {
  // const available = isAvailable(disponibilidade); // ES-868: desativado
  const FormIcon = getFormIcon(formaFarmaceutica);

  return (
    <article data-testid="medicine-card" className={styles.card}>
      <div className={styles.cardTop}>
        <FormIcon className={styles.formIcon} aria-hidden="true" />
        {/* ES-868: tag de disponível/não disponível desativada — manter para reativação futura
        <span
          className={`${styles.badge} ${available ? styles.badgeOn : styles.badgeOff}`}
          aria-label={`Disponibilidade: ${disponibilidade}`}
        >
          <span className={styles.badgeDot} aria-hidden="true" />
          {disponibilidade}
        </span>
        */}
        <span className={`${styles.badge} ${styles.badgePadronizado}`}>
          <span className={styles.badgeDot} aria-hidden="true" />
          Padronizado
        </span>
      </div>

      <div className={styles.headBlock}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.subtitle}>{formaFarmaceutica}</p>
      </div>

      <div className={styles.infoSection}>
        <div className={styles.infoBlock}>
          <div className={styles.infoHeader}>
            <PlaceOutlined
              className={styles.infoIcon}
              fontSize="small"
              aria-hidden="true"
            />
            <span className={styles.infoLabel}>Local de solicitação</span>
          </div>
          <span className={styles.infoText}>{localDeRetirada}</span>
        </div>

        <div className={styles.infoBlock}>
          <div className={styles.infoHeader}>
            <MedicalServicesOutlined
              className={styles.infoIcon}
              fontSize="small"
              aria-hidden="true"
            />
            <span className={styles.infoLabel}>Indicação clínica</span>
          </div>
          <span className={`${styles.infoText} ${styles.infoClamp}`}>{indicacao}</span>
        </div>
      </div>

      <div className={styles.tags}>
        <span
          className={styles.tag}
          aria-label={`Componente: ${componenteAgrupado}`}
        >
          {componenteAgrupado}
        </span>
        <span
          className={styles.tag}
          aria-label={`Responsabilidade: ${responsabilidade}`}
        >
          {responsabilidade}
        </span>
      </div>

    </article>
  );
};
